import { TECHNICAL_ERROR_LABELS as TECHNICAL_ERROR_LABELS_BASE, ERROR_CODES } from 'App/constants'

export const ERROR_TYPES = {
  fieldError: 'FIELD_ERROR',
  payment: 'PAYMENT',
} as const

export const TECHNICAL_ERROR_LABELS = {
  ...TECHNICAL_ERROR_LABELS_BASE,

  updateAddress: 'checkout.error.save.address',
  selectAddress: 'checkout.error.choose.address',
  invalidAddress: 'checkout.error.address.data.not.valid',
  gettingPUP: 'checkout.error.pick.up.point',
  generalDelivery: 'checkout.error.delivery.retry',
  selectPayment: 'checkout.error.payment.retry',

  proceedGeneric: 'checkout.error.proceed.generic',
  proceedDelivery: 'checkout.error.proceed.delivery',
  proceedPayment: 'checkout.error.proceed.payment',
  proceedMyInfo: 'checkout.error.proceed.myinfo',
} as const

export const CHECKOUT_ERROR_CODES = {
  emptyCart: 'EMPTY_CART',
  outOfStock: 'EMPTY_CART_OOS',
  duplicatedUID: 'DUPLICATED_UID',
  invalidDeliveryAddress: 'INVALID_DELIVERY_ADDRESS',
  insufficientStockLevel: 'INSUFFICIENT_STOCK_LEVEL',
  stockReservationFailure: 'STOCK_RESERVATION_FAILURE',
  noEntriesOnCart: 'NO_ENTRIES_ON_CART',
  noEntriesOnCartOOS: 'NO_ENTRIES_ON_CART_OOS',
  noFavoritesOnCartOOS: 'EMPTY_CART_OOS_NO_FAV',
  mixFavoritesOnCartOOS: 'EMPTY_CART_OOS_MIX_FAV',
  nullCart: 'NULL_CART',
  technicalError: ERROR_CODES.technicalError,
  wrongMethod: 'WRONG_METHOD',
  anonymous: ERROR_CODES.anonymous,
  invalidId: 'MISSING_OR_WRONG_ID',
  missingData: 'MISSING_MANDATORY_DATA',
  invalidData: 'INCORRECT_DATA',
  hazmat: 'HAZMAT',
  paymentError: 'PAYMENT_ERROR',
  paymentAborted: 'PAYMENT_ABORTED',
  paymentFailedBD1: 'PAYMENT_FAILED_BD1',
  paymentFailedBD2: 'PAYMENT_FAILED_BD2',
  paymentFailedUSBD2: 'PAYMENT_FAILED_US_BD2',
  paymentFailedTP1: 'PAYMENT_FAILED_TP1',
  paymentFailedUSTP2: 'PAYMENT_FAILED_US_TP2',
  paymentFailedRM1: 'PAYMENT_FAILED_RM1',
  paymentFailedUSRM1: 'PAYMENT_FAILED_US_RM1',
  paymentFailedRM2: 'PAYMENT_FAILED_RM2',
  paymentFailedUSRM2: 'PAYMENT_FAILED_US_RM2',
  paymentFailedUSSU1: 'PAYMENT_FAILED_US_SU1',
  paymentFailedUSSU2: 'PAYMENT_FAILED_US_SU2',
  paymentFailedVD1: 'PAYMENT_FAILED_VD1',
  paymentFailedVD2: 'PAYMENT_FAILED_VD2',
  paymentFailed803E: 'PAYMENT_FAILED_803E',
  paymentFailedIF2: 'PAYMENT_FAILED_IF2',

  nonTechnicalGiftCardError: 'NON_TECHNICAL_GIFT_CARD_ERROR',
  prepareError: 'PREPARE_ERROR',
  apiError: 'API_ERROR',
  errorExceptionThrown: 'ERROR-EXCEPTION-THROWN',
  guestCheckoutNotEnabled: 'GUEST_CHECKOUT_NOT_ENABLED',
  customerTypeNotValid: 'CUSTOMER_TYPE_NOT_VALID',
} as const

export const EMPTY_OOS_CART_ERROR = [
  CHECKOUT_ERROR_CODES.noEntriesOnCartOOS,
  CHECKOUT_ERROR_CODES.noFavoritesOnCartOOS,
  CHECKOUT_ERROR_CODES.mixFavoritesOnCartOOS,
] as ReadonlyArray<string>

export const ALL_ITEMS_OUT_OF_STOCK_ERRORS = [
  CHECKOUT_ERROR_CODES.outOfStock,
  CHECKOUT_ERROR_CODES.noEntriesOnCartOOS,
  CHECKOUT_ERROR_CODES.noFavoritesOnCartOOS,
] as ReadonlyArray<string>

export const OBSERVED_ADDRESS_FORM_ERRORS = {
  blacklist: 'blacklist',
  hazmatSupport: 'hazmatSupport',
  invalidAddressType: 'INVALID_ADDRESS_TYPE',
  invalidAddressId: 'INVALID_ADDRESS_ID',
  missingOrWrongId: 'MISSING_OR_WRONG_ID',
  invalidDeliveryAddress: CHECKOUT_ERROR_CODES.invalidDeliveryAddress,
  fieldError: ERROR_TYPES.fieldError,
} as const

export const OBSERVED_ERRORS = [
  OBSERVED_ADDRESS_FORM_ERRORS.blacklist,
  OBSERVED_ADDRESS_FORM_ERRORS.hazmatSupport,
  OBSERVED_ADDRESS_FORM_ERRORS.invalidAddressType,
  OBSERVED_ADDRESS_FORM_ERRORS.invalidAddressId,
  OBSERVED_ADDRESS_FORM_ERRORS.missingOrWrongId,
] as ReadonlyArray<string>

export const OBSERVED_BLACKLIST_ERRORS = [
  OBSERVED_ADDRESS_FORM_ERRORS.blacklist,
  OBSERVED_ADDRESS_FORM_ERRORS.hazmatSupport,
] as ReadonlyArray<string>

export const MODAL_TRIGGERING_ERROR_CODES = [
  CHECKOUT_ERROR_CODES.paymentError,
  CHECKOUT_ERROR_CODES.paymentAborted,
  CHECKOUT_ERROR_CODES.paymentFailedBD1,
  CHECKOUT_ERROR_CODES.paymentFailedBD2,
  CHECKOUT_ERROR_CODES.paymentFailedUSBD2,
  CHECKOUT_ERROR_CODES.paymentFailedTP1,
  CHECKOUT_ERROR_CODES.paymentFailedUSTP2,
  CHECKOUT_ERROR_CODES.paymentFailedRM1,
  CHECKOUT_ERROR_CODES.paymentFailedUSRM1,
  CHECKOUT_ERROR_CODES.paymentFailedRM2,
  CHECKOUT_ERROR_CODES.paymentFailedUSRM2,
  CHECKOUT_ERROR_CODES.paymentFailedUSSU2,
  CHECKOUT_ERROR_CODES.paymentFailedVD1,
  CHECKOUT_ERROR_CODES.paymentFailedVD2,
  CHECKOUT_ERROR_CODES.paymentFailed803E,
  CHECKOUT_ERROR_CODES.paymentFailedIF2,
] as ReadonlyArray<string>

export const REDIRECT_ERROR_CODES = [
  CHECKOUT_ERROR_CODES.prepareError,
  CHECKOUT_ERROR_CODES.emptyCart,
  CHECKOUT_ERROR_CODES.anonymous,
] as ReadonlyArray<string>

// GENERAL_ERROR_CODES :: all checkout api's can return any of these
export const GENERAL_ERROR_CODES = [
  ...REDIRECT_ERROR_CODES,
  CHECKOUT_ERROR_CODES.prepareError,
  CHECKOUT_ERROR_CODES.apiError,
  CHECKOUT_ERROR_CODES.wrongMethod,
] as ReadonlyArray<string>

// Don't change values below, because thery're mapped to API
export const NON_TECHNICAL_GIFT_CARD_ERROR_CODES = [
  '00',
  '03',
  '08',
  '02',
  '33',
  '16',
  '20',
  'duplicate',
] as ReadonlyArray<string>

export const GIFT_CARD_ERROR_MESSAGES = {
  '00': 'checkout.giftcard.check.zero.value',
  '03': 'checkout.giftcard.check.number.invalid',
  '08': 'checkout.giftcard.check.number.invalid',
  '02': 'checkout.giftcard.check.expired',
  33: 'checkout.giftcard.check.expired',
  16: 'checkout.giftcard.check.expired',
  20: 'checkout.giftcard.check.pin.nomatch',
  duplicate: 'checkout.giftcard.check.already.added',
} as const
